// SubscriptionManager.js
import { useEffect } from 'react';
import * as firebaseApp from 'firebase/app';
import * as firebaseMessage from 'firebase/messaging';
import APIManager from 'api/APIManager';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;
let messaging; // Firebase messaging instance
const $http = new APIManager();

const SubscriptionManager = ({ subToken, setSubToken, onMessageReceived }) => {
  useEffect(() => {
    if (!firebaseApp.getApps().length) {
      firebaseApp.initializeApp({
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
      });
    }
    enableSubscription();
    //eslint-disable-next-line
  }, []);

  const enableSubscription = async () => {
    if (!subToken) {
      try {
        messaging = firebaseMessage.getMessaging();
        const token = await firebaseMessage.getToken(messaging, {
          vapidKey: VAPID_PUBLIC_KEY,
        });
        // console.log('구독 토큰:', token);
        setSubToken(token);

        firebaseMessage.onMessage(messaging, (payload) => {
          console.log('실시간 알림 수신:', payload);
          if (onMessageReceived) onMessageReceived();
        });
      } catch (error) {
        console.error('구독 활성화 실패:', error);
      }
    }
  };

  return null;
};

// 구독 해제 함수
export const disableSubscription = async () => {
  try {
    if (messaging) {
      await firebaseMessage.deleteToken(messaging);
      console.log('구독 해제 성공');
    }
  } catch (error) {
    console.error('구독 해제 실패:', error);
  }
};

export default SubscriptionManager;

/**
 * Device 등록 및 갱신
 * --
 * @param {string} token - Firebase에서 받은 구독 토큰
 * @param {object} userInfo - 사용자 정보
 */
export const registerDevice = async (subscribe, token, userInfo) => {
  if (!token || !userInfo?.shop_information_id) return;

  try {
    // 기존 device 데이터 가져오기
    const { data: device } = await $http.get('/device', {
      shop_information_id: userInfo?.shop_information_id,
    });

    // device 데이터가 없으면 새로 등록
    if (device.length === 0) {
      await $http.post('/device', {
        shop_information_id: userInfo?.shop_information_id,
        push_token: token,
      });
      console.log('새 device 등록 완료');
    }
    // 기존 device가 있으면 토큰이 동일한지 확인 후 업데이트
    else if (device[0]?.push_token !== token) {
      await $http.put(`/device/${device[0]?.device_id}`, {
        device_id: device[0]?.device_id,
        push_token: token,
      });
      console.log('기존 device 토큰 업데이트 완료');
    }
    ApiHandler('/shop_information/store/status', subscribe, userInfo);
  } catch (error) {
    console.error('Device 등록/갱신 실패:', error);
    throw error; // 에러 발생 시 throw
  }
};

// 구독 및 구독 해제 핸들러
export const ApiHandler = async (path, type, userInfo) => {
  // console.log(type);
  // console.log(type === 'subscribe' ? 'OPEN' : 'PRE_OPEN');
  const data = {
    store_status: type === 'subscribe' ? 'OPEN' : 'PRE_OPEN',
    shop_information_id: userInfo?.shop_information_id,
  };
  const { status } = await $http.post(path, data);
  if (status === 200) {
    console.log('구독완료');
    return type === 'subscribe' ? '구독 완료' : '구독 해제 완료';
  }
  return null;
};
